<lib-form-field-container
    [kind]="FormContainerKind.Text"
    [isOptional]="isOptional"
    [hideErrors]="hideErrors">
    <ng-content
        label
        select="[label]"></ng-content>

    <ng-container readOnly>
        <div class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            {{ formControl.value }}
        </div>
    </ng-container>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-content
        bottomMenu
        select="[bottomMenu]"></ng-content>
    <ng-content outsideSuffix
        select="[outsideSuffix]"></ng-content>

    <input
        #numberinput
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [formControl]="viewControl"
        autocomplete="nope"
        [placeholder]="placeholderText"
        [attr.data-sb-qa]="qaTag"
        [maxLength]="maxCharacterLength"
        inputmode="numeric"
        (blur)="OnBlur()"
        (focus)="OnFocus()"
        (change)="$event.stopPropagation()" />
</lib-form-field-container>
